// import ButtonImage from '../../components/ButtonImage';
// import {Link, useMediaQuery} from '@material-ui/core';
// import React from 'react';
// import Grid from '@material-ui/core/Grid';
// import ButtonImageBorder from '../../components/ButtonImageBorder';
// import {application} from 'configs/app';

// export class AppBanner {
//   constructor() {
//     AppBanner.instance = this;
//   }
//   static get() {
//     if (!AppBanner.instance) {
//       AppBanner.instance = new AppBanner();
//       AppBanner.instance.limitWithdraw = 1000000;
//       AppBanner.instance.maxWithdraw = undefined;
//       AppBanner.instance.voicCall = true;
//       AppBanner.instance.videoCall = true;
//       AppBanner.instance.whiteList = [];
//     }
//     return AppBanner.instance;
//   }

//   static async fetchBannerInfo() {
//     try {
//       let response = await fetch(
//         application.endpoint + '/core/v1/setting/app-general-config/formated',
//         {
//           cache: 'no-store',
//         },
//       );

//       let resJson = await response.json();
//       let jsonArray = resJson.config;

//       const ratePattern = /^\d+$/;
//       jsonArray &&
//         jsonArray.forEach(function (item, index) {
//           /* eslint-disable default-case */
//           switch (item.id) {
//             case 'home':
//               AppBanner.get().homeBannerImage = AppBanner.getBannerView(
//                 item.url,
//                 application.endpoint + '/files/' + item.link !== null
//                   ? application.endpoint + '/files/' + item.link
//                   : null,
//               );
//               break;
//             case 'homeNew':
//               AppBanner.get().homeNewBannerImage =
//                 AppBanner.getBannerViewBorder(
//                   item.url,
//                   application.endpoint + '/files/' + item.link !== null
//                     ? application.endpoint + '/files/' + item.link
//                     : null,
//                 );
//               break;
//             case 'homeNewAndroid':
//               AppBanner.get().androidBannerImage =
//                 AppBanner.getBannerViewAndroidBorder(
//                   item.url,
//                   application.endpoint + '/files/' + item.link !== null
//                     ? application.endpoint + '/files/' + item.link
//                     : null,
//                 );
//               break;
//             case 'social':
//               AppBanner.get().socialBannerImage = AppBanner.getBannerView(
//                 item.url,
//                 application.endpoint + '/files/' + item.link !== null
//                   ? application.endpoint + '/files/' + item.link
//                   : null,
//               );
//               break;
//             case 'damopet':
//               AppBanner.get().damopetBannerImage = AppBanner.getBannerView(
//                 item.url,
//                 application.endpoint + '/files/' + item.link !== null
//                   ? application.endpoint + '/files/' + item.link
//                   : null,
//               );
//               break;
//             case 'advisers':
//               AppBanner.get().advisersBannerImage = AppBanner.getBannerView(
//                 item.url,
//                 application.endpoint + '/files/' + item.link !== null
//                   ? application.endpoint + '/files/' + item.link
//                   : null,
//               );
//               break;
//             case 'limitWithdraw':
//               if (ratePattern.test(item.value)) {
//                 AppBanner.get().limitWithdraw = item.value;
//               }
//               break;
//             case 'maxWithdraw':
//               if (ratePattern.test(item.value)) {
//                 AppBanner.get().maxWithdraw = item.value;
//               }
//               break;
//             case 'rtcSetting':
//               AppBanner.get().voicCall = item.voiceCall === true;
//               AppBanner.get().videoCall = item.videoCall === true;
//               AppBanner.get().whiteList = item.whiteList;
//               break;
//             case 'questions':
//               AppBanner.get().questions = item.value;
//               break;
//           }
//           /* eslint-enable default-case */
//         });
//     } catch (error) {
//       console.error(error);
//     }
//   }

//   static getBannerById(id) {
//     /* eslint-disable default-case */

//     switch (id) {
//       case 'homeNew':
//         return AppBanner.get().homeNewBannerImage;
//       case 'home':
//         return AppBanner.get().homeBannerImage;
//       case 'homeNewAndroid':
//         return AppBanner.get().androidBannerImage;
//       case 'social':
//         return AppBanner.get().socialBannerImage;
//       case 'damopet':
//         return AppBanner.get().damopetBannerImage;
//       case 'advisers':
//         return AppBanner.get().advisersBannerImage;
//     }
//     /* eslint-enable default-case */

//     return null;
//   }

//   static getBannerView(url, link) {
//     return (
//       <Grid item>
//         <ButtonImage
//           src={link}
//           component={Link}
//           href={url}
//           target={'_self'}
//           rel="noopener"
//         />
//       </Grid>
//     );
//   }

//   static getBannerViewBorder(url, link) {
//     return (
//       <Grid item>
//         <ButtonImageBorder
//           android={false}
//           src={link}
//           component={Link}
//           href={url}
//           target={'_self'}
//           rel="noopener"
//         />
//       </Grid>
//     );
//   }

//   static getBannerViewAndroidBorder(url, link) {
//     return (
//       <Grid item>
//         {/* <ButtonImage
//           src={link}
//           component={Link}
//           href={url}
//           target={'_self'}
//           rel="noopener"
//         /> */}
//         <ButtonImageBorder
//           android={true}
//           src={link}
//           component={Link}
//           href={url}
//           target={'_self'}
//           rel="noopener"
//         />
//       </Grid>
//     );
//   }
// }
import ButtonImage from '../../components/ButtonImage';
import {Link} from '@material-ui/core'; // If using MUI v5+, change to '@mui/material/Link'
import React from 'react';
import Grid from '@material-ui/core/Grid';
import {application} from 'configs/app';
import ButtonImageBorderHome from 'components/ButtonImageBorderHome';
import ResponsiveBanner from 'components/ResponsiveBanner';

export class AppBanner {
  static instance = null;

  constructor() {
    this.initDefaults();
  }

  initDefaults() {
    this.limitWithdraw = 1000000;
    this.maxWithdraw = undefined;
    this.voicCall = true;
    this.videoCall = true;
    this.whiteList = [];
    this.homeNewBanners = [];
    this.androidHomeNewBanners = [];
  }

  static get() {
    if (!AppBanner.instance) {
      AppBanner.instance = new AppBanner();
    }
    return AppBanner.instance;
  }

  static async fetchBannerInfo() {
    try {
      const response = await fetch(
        application.endpoint + '/core/v1/setting/app-general-config/formated',
        {cache: 'no-store'},
      );

      const resJson = await response.json();
      const jsonArray = resJson.config;

      const ratePattern = /^\d+$/;

      jsonArray &&
        jsonArray.forEach((item) => {
          const link = item.link
            ? application.endpoint + '/files/' + item.link
            : null;

          switch (item.id) {
            case 'home':
              AppBanner.get().homeBannerImage = AppBanner.getBannerView(
                item.url,
                link,
              );
              break;
            case 'social':
              AppBanner.get().socialBannerImage = AppBanner.getBannerView(
                item.url,
                link,
              );
              break;
            case 'damopet':
              AppBanner.get().damopetBannerImage = AppBanner.getBannerView(
                item.url,
                link,
              );
              break;
            case 'advisers':
              AppBanner.get().advisersBannerImage = AppBanner.getBannerView(
                item.url,
                link,
              );
              break;
            case 'homeCareBanner':
              AppBanner.get().homeCareBanner = {url: item.url, link};
              break;
            case 'vetBanner':
              AppBanner.get().vetBanner = {url: item.url, link};
              break;
            case 'adsBanner':
              AppBanner.get().adsBanner = {url: item.url, link};
              break;
            case 'spacialBanner':
              AppBanner.get().spacialBanner = {url: item.url, link};
              break;
            case 'doctorBanner':
              AppBanner.get().doctorBanner = {url: item.url, link};
              break;
            case 'consultantBanner':
              AppBanner.get().consultantBanner = {url: item.url, link};
              break;
            case 'limitWithdraw':
              if (ratePattern.test(item.value)) {
                AppBanner.get().limitWithdraw = item.value;
              }
              break;
            case 'maxWithdraw':
              if (ratePattern.test(item.value)) {
                AppBanner.get().maxWithdraw = item.value;
              }
              break;
            case 'rtcSetting':
              AppBanner.get().voicCall = item.voiceCall === true;
              AppBanner.get().videoCall = item.videoCall === true;
              AppBanner.get().whiteList = item.whiteList;
              break;
            case 'questions':
              AppBanner.get().questions = item.value;
              break;
            default:
              if (item.id.startsWith('homeNewAndroid')) {
                AppBanner.get().androidHomeNewBanners.push({
                  id: item.id,
                  url: item.url,
                  link,
                });
              } else if (item.id.startsWith('homeNew')) {
                AppBanner.get().homeNewBanners.push({
                  id: item.id,
                  url: item.url,
                  link,
                });
              }
              break;
          }
        });

      // Sort homeNewBanners
      AppBanner.get().homeNewBanners.sort((a, b) => {
        const numA = parseInt(a.id.replace('homeNew', ''), 10) || 0;
        const numB = parseInt(b.id.replace('homeNew', ''), 10) || 0;
        return numA - numB;
      });
    } catch (error) {
      console.error(error);
    }
  }

  static getBannerById(id) {
    switch (id) {
      case 'homeNew':
        return AppBanner.getHomeNewBannerView();
      case 'home':
        return AppBanner.get().homeBannerImage;
      case 'homeNewAndroid':
        return AppBanner.getHomeNewBannerViewAndroid();
      case 'social':
        return AppBanner.get().socialBannerImage;
      case 'damopet':
        return AppBanner.get().damopetBannerImage;
      case 'advisers':
        return AppBanner.get().advisersBannerImage;
      case 'homeCare':
      case 'homeCareBanner':
        return AppBanner.getResponsiveBannerView('homeCareBanner');
      case 'vet':
      case 'vetBanner':
        return AppBanner.getResponsiveBannerView('vetBanner');
      case 'ads':
      case 'adsBanner':
        return AppBanner.getResponsiveBannerView('adsBanner');
      case 'special':
      case 'spacialBanner':
        return AppBanner.getResponsiveBannerView('spacialBanner');
      case 'doctor':
      case 'doctorBanner':
        return AppBanner.getResponsiveBannerView('doctorBanner');
      case 'consultant':
      case 'consultantBanner':
        return AppBanner.getResponsiveBannerView('consultantBanner');
      default:
        return null;
    }
  }

  static getHomeNewBannerView() {
    const banners = AppBanner.get().homeNewBanners;
    if (!banners?.length) return null;

    return <ButtonImageBorderHome banners={banners} android={false} />;
  }

  static getHomeNewBannerViewAndroid() {
    const banners = AppBanner.get().androidHomeNewBanners;
    if (!banners?.length) return null;

    return <ButtonImageBorderHome banners={banners} android={true} />;
  }

  static getResponsiveBannerView(id) {
    const banner = AppBanner.get()[id];
    if (!banner?.link) return null;

    return <ResponsiveBanner banner={banner} />;
  }

  static getBannerView(url, link) {
    return (
      <Grid item>
        <ButtonImage
          src={link}
          component={Link}
          href={url}
          target={'_self'}
          rel="noopener"
        />
      </Grid>
    );
  }
}
